import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Envelope icon for representing email or messages
 */
export const EnvelopeIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
      <path d="M22 7l-10 5-10-5"></path>
    </Icon>
  );
};

export default EnvelopeIcon;
